var _dec, _class, _descriptor, _dec2, _dec3, _dec4, _class2, _descriptor2, _descriptor3, _descriptor4, _dec5, _dec6, _class3, _descriptor5, _descriptor6, _dec7, _dec8, _dec9, _dec0, _class4, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _dec1, _dec10, _dec11, _dec12, _dec13, _class5, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../../Decorators/objectArrayTrait";
import objectTrait from "../../Decorators/objectTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import mixTraits from "../../mixTraits";
import ModelTraits from "../../ModelTraits";
import { BinStyleTraits, EnumStyleTraits, TableStyleMapSymbolTraits, TableStyleMapTraits } from "./StyleMapTraits";

/** Supports CZML SolidColorMaterial https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/SolidColorMaterial */
export let SolidColorMaterialTraits = (_dec = primitiveTrait({
  name: "Color",
  description: "The color.",
  type: "string"
}), _class = class SolidColorMaterialTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "color", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "color", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "#ffffff";
  }
}), _class);

/** Supports CZML PolylineGlowMaterial https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/PolylineGlowMaterial */
export let PolylineGlowMaterialTraits = (_dec2 = primitiveTrait({
  name: "Color",
  description: "The color.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "Glow power",
  description: "The strength of the glow, as a percentage of the total line width.",
  type: "number"
}), _dec4 = primitiveTrait({
  name: "Glow taper power",
  description: "The strength of the glow tapering effect, as a percentage of the total line length. If 1.0 or higher, no taper effect is used.",
  type: "number"
}), _class2 = class PolylineGlowMaterialTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "color", _descriptor2, this);
    _initializerDefineProperty(this, "glowPower", _descriptor3, this);
    _initializerDefineProperty(this, "taperPower", _descriptor4, this);
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "color", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "#ffffff";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "glowPower", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.25;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "taperPower", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _class2);

/** Supports subset of CZML PolylineMaterial https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/PolylineMaterial
 *
 * Unimplemented materials
 * - polylineOutline
 * - polylineArrow
 * - polylineDash
 * - image
 * - grid
 * - stripe
 * - checkerboard
 */
export let PolylineMaterialTraits = (_dec5 = objectTrait({
  type: PolylineGlowMaterialTraits,
  name: "Polyline glow material",
  description: 'Polyline glow material. Must also set `materialType = "polylineGlow"`'
}), _dec6 = objectTrait({
  type: SolidColorMaterialTraits,
  name: "Solid color material",
  description: "Solid color material."
}), _class3 = class PolylineMaterialTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "polylineGlow", _descriptor5, this);
    _initializerDefineProperty(this, "solidColor", _descriptor6, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "polylineGlow", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "solidColor", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);

/** Supports subset of CZML Path https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/Path
 *
 * Unimplemented properties
 * - show
 * - distanceDisplayCondition
 *
 * Note: materials is handled slightly differently
 */
export let TrailSymbolTraits = (_dec7 = primitiveTrait({
  name: "Lead time",
  description: "The number of seconds in front of the object to show.",
  type: "number"
}), _dec8 = primitiveTrait({
  name: "Trail time",
  description: "The number of seconds behind the object to show.",
  type: "number"
}), _dec9 = primitiveTrait({
  name: "Width",
  description: "The width in pixels.",
  type: "number"
}), _dec0 = primitiveTrait({
  name: "Resolution",
  description: "The maximum number of seconds to step when sampling the position.",
  type: "number"
}), _class4 = class TrailSymbolTraits extends mixTraits(PolylineMaterialTraits, TableStyleMapSymbolTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "leadTime", _descriptor7, this);
    _initializerDefineProperty(this, "trailTime", _descriptor8, this);
    _initializerDefineProperty(this, "width", _descriptor9, this);
    _initializerDefineProperty(this, "resolution", _descriptor0, this);
  }
}, _descriptor7 = _applyDecoratedDescriptor(_class4.prototype, "leadTime", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class4.prototype, "trailTime", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class4.prototype, "width", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class4.prototype, "resolution", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 60;
  }
}), _class4);
export class EnumTrailSymbolTraits extends mixTraits(TrailSymbolTraits, EnumStyleTraits) {}
_defineProperty(EnumTrailSymbolTraits, "isRemoval", EnumStyleTraits.isRemoval);
export class BinTrailSymbolTraits extends mixTraits(TrailSymbolTraits, BinStyleTraits) {}
_defineProperty(BinTrailSymbolTraits, "isRemoval", BinStyleTraits.isRemoval);
let TableTrailStyleTraits = (_dec1 = primitiveTrait({
  name: "Enabled",
  description: "True to enable. False by default",
  type: "boolean"
}), _dec10 = primitiveTrait({
  name: "Material type",
  description: "The type of material to use. Possible values: `solidColor` and `polylineGlow`. Default is `solidColor`",
  type: "string"
}), _dec11 = objectArrayTrait({
  name: "Enum Colors",
  description: "The colors to use for enumerated values. This property is ignored " + "if the `Color Column` type is not `enum`.",
  type: EnumTrailSymbolTraits,
  idProperty: "value"
}), _dec12 = objectArrayTrait({
  name: "Enum Colors",
  description: "The colors to use for enumerated values. This property is ignored " + "if the `Color Column` type is not `enum`.",
  type: BinTrailSymbolTraits,
  idProperty: "index"
}), _dec13 = objectTrait({
  name: "Enum Colors",
  description: "The colors to use for enumerated values. This property is ignored " + "if the `Color Column` type is not `enum`.",
  type: TrailSymbolTraits
}), _class5 = class TableTrailStyleTraits extends mixTraits(TableStyleMapTraits) {
  constructor() {
    super(...arguments);
    // Override TableStyleMapTraits.enabled default
    _initializerDefineProperty(this, "enabled", _descriptor1, this);
    _initializerDefineProperty(this, "materialType", _descriptor10, this);
    _initializerDefineProperty(this, "enum", _descriptor11, this);
    _initializerDefineProperty(this, "bin", _descriptor12, this);
    _initializerDefineProperty(this, "null", _descriptor13, this);
  }
}, _descriptor1 = _applyDecoratedDescriptor(_class5.prototype, "enabled", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class5.prototype, "materialType", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "solidColor";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class5.prototype, "enum", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class5.prototype, "bin", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class5.prototype, "null", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new TrailSymbolTraits();
  }
}), _class5);
export { TableTrailStyleTraits as default };